import * as actionTypes from '../../constants/actionTypes';
import * as requestTypes from '../../constants/requestTypes';
import fn from 'when/function';
import { has } from 'lodash';
import JSONUtils from '../../lib/JSONUtils';
import { CALL_PRIVATE_API } from '../../middleware/api';
import { setRequestInProcess } from '../request';
import { WHITELABEL_SETTINGS } from '../../constants/config';
import { GET } from '../../constants/requestMethods';
import { ACLQueryModeTypes } from '../../constants/visibilityFilters';
import { vendorSchema } from '../../schemas';
import { commonConnectors } from 'new/constants/featureFlags';

function pagingSignalSuccess(paging) {
  return {
    type: actionTypes.PAGING_SIGNAL_SUCCESS,
    paging,
  };
}

function pagingSignalFailure(error) {
  return {
    type: actionTypes.PAGING_SIGNAL_FAILURE,
    error,
  };
}

function setCommonConnectorsSuccess(commonConnectors) {
  return {
    type: actionTypes.SET_COMMON_CONNECTORS_SUCCESS,
    commonConnectors,
  };
}

function setCommonConnectorsFailure(error) {
  return {
    type: actionTypes.SET_COMMON_CONNECTORS_FAILURE,
    error,
  };
}

// function getMockPagingData() {
//   return JSONUtils.parseJson(PAGING_RESPONSE);
// }

const getMockPagingData = async () => {
  let pagingSpec = null;

  switch (WHITELABEL_SETTINGS.pagingMode) {
    case 'sample-wl':
      pagingSpec = await import('../../../mocks/connectors/sample-wl/connectorSpec');
      break;

    default:
      pagingSpec = await import('../../../mocks/connectors/default/connectorSpec');
      break;
  }

  const pagingContent = pagingSpec.CONNECTOR_SPECS;
  return pagingContent;
};

export const getCommonConnectors = () => (dispatch) => {
  return dispatch({
    [CALL_PRIVATE_API]: {
      types: [
        actionTypes.GET_COMMON_CONNECTORS_REQUEST,
        actionTypes.GET_COMMON_CONNECTORS_SUCCESS,
        actionTypes.GET_COMMON_CONNECTORS_FAILURE,
      ],
      endpoint: '/connectors?common=true&limit=6',
      schema: [vendorSchema],
      requestMethod: GET,
      aclQueryMode: ACLQueryModeTypes.MODE_OWNER.key,
    },
  });
};

export const getCommonConnectorsFeatureData = () => (dispatch) => {
  const featureFlagData = commonConnectors();
  const hasFeatureFlagData = featureFlagData && Object.keys(featureFlagData).length > 0;
  if (hasFeatureFlagData) {
    dispatch(setCommonConnectorsSuccess(featureFlagData));
  }
  return Promise.resolve();
};

export const getPagingData = () => async (dispatch) => {
  const requestType = requestTypes.PAGING_INFO;

  dispatch(setRequestInProcess(true, requestType));

  // Check feature flag and populate common connectors accordingly
  const featureFlagData = commonConnectors();
  const hasFeatureFlagData = featureFlagData && Object.keys(featureFlagData).length > 0;

  if (hasFeatureFlagData) {
    // Use feature flag data
    dispatch(setCommonConnectorsSuccess(featureFlagData));
  } else {
    // Make API call for common connectors if feature flag is off
    // Feature flag should only be removed after API is implemented
    try {
      await dispatch(getCommonConnectors());
    } catch (commonConnectorsError) {
      console.log('Failed to load common connectors from API:', commonConnectorsError);
      dispatch(setCommonConnectorsFailure(commonConnectorsError));
    }
  }

  return fn
    .call(getMockPagingData)
    .then(
      (rsp) => {
        if (rsp && has(rsp, 'connections')) {
          dispatch(pagingSignalSuccess(rsp.connections));
          dispatch(setRequestInProcess(false, requestType));
          return Promise.resolve();
        } else {
          return Promise.reject('Could not find spec');
        }
      },
      (err) => {
        return Promise.reject('Could not find spec');
      },
    )
    .catch((err) => {
      console.log('ERR', err);
      dispatch(pagingSignalFailure(err));
      dispatch(setRequestInProcess(false, requestType));
    });
};
